import { Box, Card, Container, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        height: '100%', // You can adjust this based on your layout requirements
        flexWrap: 'wrap',
    },
    box: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #ccc',
        padding: theme.spacing(2),
        margin: theme.spacing(1),
        minHeight: '300px',
        minWidth: '250px',
    },
}));

type Props = {};

const DeclareIncapacity: React.FC<Props> = () => {
    const classes = useStyles();
    return (
        <Container style={{ height: '100%' }}>
            <Card style={{ height: '100%', paddingLeft: '50px', paddingRight: '50px' }}>
                <Box className={classes.container}>
                    <strong>En construction...</strong>
                </Box>
            </Card>
        </Container>
    );
};

export default DeclareIncapacity;
